import { useTranslations } from '@vocab/react';
import { Box, Text, Strong } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

interface Props {
  searchTerm?: string;
}

const NoBrandResults = ({ searchTerm }: Props) => {
  const { t } = useTranslations(translations);
  return (
    <Box style={{ height: 200 }}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="full"
      >
        <Text size="large" tone="secondary">
          {t('We could not find any brands matching your query')}
          <Strong>{searchTerm}</Strong>
        </Text>
      </Box>
    </Box>
  );
};

export default NoBrandResults;
